export const PolicyList = 'PolicyList';
export const GET_POLICY_LIST_DATA = 'GET_POLICY_LIST_DATA';
